import { Form, Input, Switch } from "antd";
import { requiredField } from "../common/common";

export default function TagFields() {
  return (
    <>
      <Form.Item
        name="name"
        label="Nome"
        rules={[requiredField, { whitespace: true, message: "Inserisci un nome" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="includeInHseDocuments"
        label="Includi nei documenti HSE"
        valuePropName="checked"
        initialValue={false}
      >
        <Switch />
      </Form.Item>
      <Form.Item
        name="requiresDueDate"
        label="Richiede scadenza"
        valuePropName="checked"
        initialValue={false}
      >
        <Switch />
      </Form.Item>
    </>
  );
}
